import { takeLatest } from 'redux-saga/effects';
import { login } from "./sagas/login";
import { addClient, updateClient, removeClient, getClients } from "./sagas/client";
import { addBranch, updateBranch, removeBranch } from "./sagas/branch";
import { addRoom, updateRoom, removeRoom, getRooms } from "./sagas/room";
import { addVoucher, updateVoucher, removeVoucher, checkVoucher, getVouchers } from "./sagas/voucher";
import { getDashboard } from "./sagas/dashboard";

export default function* root() {
  yield [
    takeLatest('LOGIN_RESQUEST', login),
    takeLatest('ADD_CLIENT', addClient),
    takeLatest('UPDATE_CLIENT', updateClient),
    takeLatest('REMOVE_CLIENT', removeClient),
    takeLatest('GET_CLIENTS', getClients),
    takeLatest('ADD_BRANCH', addBranch),
    takeLatest('UPDATE_BRANCH', updateBranch),
    takeLatest('REMOVE_BRANCH', removeBranch),
    takeLatest('ADD_ROOM', addRoom),
    takeLatest('UPDATE_ROOM', updateRoom),
    takeLatest('REMOVE_ROOM', removeRoom),
    takeLatest('GET_ROOMS', getRooms),
    takeLatest('ADD_VOUCHER', addVoucher),
    takeLatest('UPDATE_VOUCHER', updateVoucher),
    takeLatest('REMOVE_VOUCHER', removeVoucher),
    takeLatest('CHECK_VOUCHER', checkVoucher),
    takeLatest('GET_VOUCHERS', getVouchers),
    takeLatest('GET_DASHBOARD', getDashboard),
  ];
}



// WEBPACK FOOTER //
// ./src/store/sagas.js